import React from "react";
import {CALENDER_ICON, CHART_ICON } from "assets/constants/Icons";
import moment from 'moment';

const ChatterPage = () => {
  return (<>
    {
       (
        <div className="main-content">
          <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
            <div className="col-md-10 sm_device"><i className={`${CHART_ICON}`}></i> Notifications Page</div>
            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
          </div>
          <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
          <div className="list-wrapper">
              <h4>🔔 System Alerts</h4>
              
              <div className="card-body text-justify">
              <h5>Credit & Usage Alerts</h5>
                <p className="faq-para-class" id="para-id-6">
                  <ul>
                    <li>⚠️ Your credits are running low! You have <b>120 credits left.</b> Recharge now to avoid interruptions. </li>
                    <li>⏳ Free trial ending soon! Only <b>2 days left</b> before your trial expires. Upgrade today. </li>
                    <li>📊 High usage alert: You’ve used <b>80% of your monthly credits.</b> Plan your next recharge.</li>
                  </ul>
                </p>
              </div>

              <div className="card-body text-justify">
              <h5>Offers & Promotions</h5>
                <p className="faq-para-class" id="para-id-6">
                  <ul>
                    <li>🎉 Special Offer: Get <b>20% extra credits</b> on your next recharge. Limited time only! </li>
                    <li>🏷️ Festive Deal: Unlock <b>50 free credits</b> when you refer a friend. </li>
                    <li>💡 Upgrade & Save: Switch to a yearly plan and save <b>25%.</b> instantly.</li>
                  </ul>
                </p>
              </div>

              <div className="card-body text-justify">
              <h5>System & Account Updates</h5>
                <p className="faq-para-class" id="para-id-6">
                  <ul>
                    <li>🔐 Security Notice: We’ve updated our login process for better protection. Please re-verify your account. </li>
                    <li>📥 Export Ready: Your requested <b>report is now available for download.</b> </li>
                    <li>💡 Upgrade & Save: Switch to a yearly plan and save <b>25%.</b> instantly.</li>
                  </ul>
                </p>
              </div>
          </div>
        </div>
      )
    }
  </>);
}

export default ChatterPage;